import { AxiosResponse } from "axios";

import API from "../api";

import { CompanyConfig } from "Models/company.config";
import { NetworkConfiguration } from "../pages/private/Shared/Settings/Configurations/General/Network/types";

const ROUTE_NAME = "company-configs";

export const CompanyConfigsService = {
  async getCurrent(): Promise<AxiosResponse<CompanyConfig>> {
    return await API.get(`/${ROUTE_NAME}`);
  },

  async getByCreatedCompany(jobIds: number[] = []): Promise<AxiosResponse<{
    [jobId: number]: NetworkConfiguration
  }>> {
    return await API.get(`/${ROUTE_NAME}/get-by-created-company/?jobIds=${jobIds.join(",")}`);
  },

  async saveCurrent(companyConfigs: Partial<CompanyConfig>): Promise<AxiosResponse<CompanyConfig>> {
    return await API.put(`/${ROUTE_NAME}`, companyConfigs);
  },
};
